__turbopack_context__.v({
  "text-input": "MDISJG_text-input",
  "text-input--with-icon": "MDISJG_text-input--with-icon",
  "text-input__custom-icon": "MDISJG_text-input__custom-icon",
  "text-input__reset-button": "MDISJG_text-input__reset-button",
  "text-input__wrapper": "MDISJG_text-input__wrapper",
});
